<template>
	<div class="processing failed">
		<div class="customer-name-wrap">
			<span v-if="customerNameToPrint" class="customer-name">
				{{ customerNameToPrint }}
			</span>
		</div>
		<img
			class="placeholder-failed"
			:src="beveragePlaceholder"
			alt="beverage placeholder image"
		/>
		<span class="processing-status">ORDER PROCESSING FAILED</span>
		<span class="processing-description">
			SELF ORDERING IS NOT AVAILABLE AT THIS MOMENT
		</span>
		<button
			class="button without-border-radius"
			:class="{ disabled: isLoading }"
			@click="$emit('retry')"
		>
			Refresh
		</button>
	</div>
</template>

<script>
import BeveragePlaceholder from '@/assets/images/beverage_placeholder_nodata.svg'

export default {
	name: 'ProcessingFailed',
	props: {
		customerNameToPrint: {
			type: String,
			default: ''
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			beveragePlaceholder: BeveragePlaceholder
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.processing {
	position: absolute;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%;
	padding: 48px 24px 24px;
	text-transform: uppercase;
	text-align: center;

	&.failed .customer-name-wrap {
		padding: 0 0 123px;
	}
}

.customer-name-wrap {
	min-height: 40px;
	padding: 0 0 10px;
}

.customer-name {
	font-size: 16px;
	font-weight: 700;
	color: #1d1b25;
	text-transform: none;
	letter-spacing: 1px;
}

.placeholder-failed {
	display: block;
	margin: 0 auto 74px;
}

.processing-status {
	display: inline-block;
	padding: 0 20px 12px;
	margin: 0 0 8px;
	font-size: 20px;
	color: #816cc2;
	border-bottom: 1px solid #554781;
}

.processing-description {
	display: block;
	max-width: 244px;
	margin: 0 auto 22px;
	line-height: 1.4;
	color: $white;
}

.button {
	min-width: 136px;
}

@media (max-width: 767px) {
	.processing {
		padding: 24px 12px 12px;

		&.failed .customer-name-wrap {
			padding: 0 0 104px;
		}
	}

	.placeholder-failed {
		margin: 0 auto 26px;
	}
}
</style>
